import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Link from "@mui/material/Link";

export const ReturnDisclaimer = () => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Information
      </Typography>
      <Typography>
        Please print off the Returns Document and place it in the box with your
        items. Failure to do so may result in your return being delayed or
        rejected.
      </Typography>
      <List>
        <ListItem>
          All values and prices are provisional and subject to change after the
          inspection of returned goods.
        </ListItem>
        <ListItem>
          Goods must be returned in a re-saleable condition to receive a full
          credit.
        </ListItem>
        <ListItem>
          Goods that are not in a re-saleable condition may be subject to a
          re-stocking charges.
        </ListItem>
        <ListItem>
          The return carriage charge is £7.95 per bag or box. No charge will
          apply and the original carriage will be refunded if the reason for
          return is the fault of Peter Drew Contracts Ltd.
        </ListItem>
        <ListItem>
          <Typography>
            Full Terms and Conditions can be found{" "}
            <Link href="https://peterdrew.com/returns">here.</Link>
          </Typography>
        </ListItem>
      </List>
    </Paper>
  );
};
